var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInfoFormField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 20,
    maskUnits: "userSpaceOnUse",
    width: 20,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 10c0-5.5177 4.4823-10 10-10s10 4.4823 10 10-4.4823 10-10 10-10-4.4823-10-10zm19.1304 0c0-5.04775-4.0827-9.130435-9.1304-9.130435-5.04775 0-9.130435 4.082685-9.130435 9.130435 0 5.0477 4.082685 9.1304 9.130435 9.1304 5.0477 0 9.1304-4.0827 9.1304-9.1304zm-9.1304-6.08696c-.72037 0-1.30435.58398-1.30435 1.30435s.58398 1.30435 1.30435 1.30435c.7204 0 1.3043-.58398 1.3043-1.30435s-.5839-1.30435-1.3043-1.30435zm-1.73913 5.21739v-.86956h.43478 1.73915.4348v6.52173h.4347.4348v.8696h-.4348-.4347-1.73917-.43478-.43478v-.8696h.43478.43478v-5.65217h-.43478z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m-2 22h24v-24h-24z",
    fill: "#8e8e93",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoFormField);
export default __webpack_public_path__ + "static/media/ico_info_form_field.adf7bfbc7bcd65739a81074aac46d158.svg";
export { ForwardRef as ReactComponent };